module.exports = __webpack_public_path__ + "2eabb316862295e9494a270a2f1140b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/tiyan/tiyan1.jpg
// module id = 1230
// module chunks = 0